<script setup lang="ts">
import { vOnClickOutside } from '@vueuse/components'
import { mdiEyeOutline } from '@mdi/js'
import type { SearchHit } from '../interfaces/search'
import SearchResultMenuTable from './SearchResultMenuTable.vue'
import MotionProgressBar from '@/modules/motion/components/list/MotionProgressBar.vue'
import PrimaryButton from '@/shared/components/button/PrimaryButton.vue'
import SearchResultMenuClient from './SearchResultMenuClient.vue'

interface Props {
  loading: boolean
  items: SearchHit[]
}

interface Emits {
  (e: 'click'): void
}

defineOptions({ inheritAttrs: false })
defineProps<Props>()
const emits = defineEmits<Emits>()
const model = defineModel<SearchHit>()
const active = defineModel<boolean>('active', { required: true })

const onView = () => {
  emits('click')
}
</script>

<template>
  <div
    class="z-40 absolute border-x border-b border-gray-300 bg-white transition-all transform ease-in-out duration-200 w-full focus:outline-none shadow-md"
    :class="active ? 'opacity-100' : 'opacity-0 collapse'"
    v-on-click-outside="() => (active = false)"
  >
    <MotionProgressBar :loading="loading" />
    <div class="relative">
      <div v-if="items.length > 0" class="p-4">
        <SearchResultMenuClient
          v-if="active"
          :title="$t('common.open')"
          v-model="model"
          :items="items"
          :loading="loading"
          :disabled="items.length === 0"
        />
        <SearchResultMenuTable v-model="model" :result="items" :items="items" :loading="loading" class="pt-2" />
        <div v-if="model && model.clientKey" class="flex items-center justify-end pt-4">
          <PrimaryButton
            :text="$t('common.view')"
            :icon="mdiEyeOutline"
            @click="onView()"
            :disabled="items.length === 0"
          />
        </div>
      </div>
      <div v-if="!loading && !model">
        <div class="font-light text-sm text-gray-700 text-center py-4">
          {{ $t('message.noSearchTermMatch') }}
        </div>
      </div>
    </div>
  </div>
</template>
